module.exports = __webpack_public_path__ + "img/enthusiastic.cbbee152.png";